var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#A7AEBC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 401 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1317 17.9528C9.7175 17.9528 9.38171 17.617 9.38171 17.2028L9.38171 4.87129L4.7534 9.49961C4.4605 9.7925 3.98563 9.7925 3.69274 9.49961C3.39984 9.20672 3.39984 8.73184 3.69274 8.43895L9.60138 2.5303C9.89428 2.23741 10.3692 2.23741 10.662 2.5303L16.5707 8.43895C16.8636 8.73184 16.8636 9.20672 16.5707 9.49961C16.2778 9.7925 15.8029 9.7925 15.51 9.49961L10.8817 4.87129L10.8817 17.2028C10.8817 17.617 10.5459 17.9528 10.1317 17.9528Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f0a8138b.svg";
export { ForwardRef as ReactComponent };